<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="billit" class="font-weight-bold" height="35">Add {{ $store.getters.locU }}</v-btn>
    </template>
    
    <v-card>
      <v-card-title>
        Add A New {{ $store.getters.locU }}
        <v-spacer />

        <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="body-1 text-center">
        <v-form>
          <v-text-field
            outlined dense v-model="name"
            :label="`Name of ${ $store.getters.locU }`"
          ></v-text-field>
          <v-layout>
            <v-flex xs6>
              <v-select
                :items="$store.state.stateSelect"
                v-model="state"
                label="State"
                outlined dense
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                :items="$store.getters.citySelect(state)"
                v-model="city" class="pl-3"
                label="City" outlined dense
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- <v-text-field
            outlined dense v-model="address"
            label="Address"
          ></v-text-field> -->
          <!-- <v-text-field
            outlined dense v-model="accessCode"
            label="Verify Access Code" type="password"
          ></v-text-field> -->
        </v-form>
        <v-btn
          class="mt-3"
          color="info"
          depressed
          default :loading="loading"
          rounded
          @click="addLocation"
        >Add</v-btn>
        <p class="red--text mt-5" v-if="feedback">{{ feedback }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { functions } from '@/firebase'

export default {
  data() {
    return {
      dialog: false,
      name: '',
      state: null,
      city: null,
      address: '',
      // accessCode: '',
      loading: false,
      feedback: '',
    }
  },
  methods: {
    addLocation() {
      this.feedback = ''
      this.loading = true

      const { state, city, address, name } = this.$data
      let f = functions.httpsCallable('addLocation')
      f({state, city, name})
      .then(result => {
        this.loading = false
        this.dialog = false
      })
      .catch(error => {
        this.loading = false
        this.feedback = error.message
      })
    }
  }
}
</script>